import { api } from "../../services/api";

const service_path = '/gold-price.php';

export async function getGoldPrice() {

    const { data } = await api.get(`${service_path}?`);

    return data;
};